import { render } from "./FeedbackRequestsList.vue?vue&type=template&id=2ce1854a&scoped=true"
import script from "./FeedbackRequestsList.vue?vue&type=script&lang=js"
export * from "./FeedbackRequestsList.vue?vue&type=script&lang=js"

import "./FeedbackRequestsList.vue?vue&type=style&index=0&id=2ce1854a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce1854a"]])

export default __exports__